import React from 'react';

import styled, { withTheme, keyframes } from 'styled-components';

import { LOADER_TEXT } from 'constants/message';

const SpinnerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.2);
    z-index: 9999;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

const spin = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

const Spinner = styled.span`
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    border: 3px solid ${props => props.theme.palette.primary.loaderBG};
    border-top-color: ${props => props.theme.palette.primary.main};
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
`;

const RetryingText = styled.p`
    margin: 28px 0 0;
    font-family: ${props =>
        props.theme.palette.fontFamily || '"Roboto", sans-serif'};
    font-size: 24px;
    font-weight: 400;
    line-height: 130%;
    color: ${props => props.theme.palette.primary.text || '#313131'};
    text-align: center;
`;

function RetryingIndicator() {
    return (
        <SpinnerContainer data-testid="retrying-indicator">
            <Content>
                <Spinner data-testid="retrying-indicator-spinner" />
                <RetryingText>{LOADER_TEXT.RETRYING}</RetryingText>
            </Content>
        </SpinnerContainer>
    );
}

export default withTheme(RetryingIndicator);
